import React from "react";

import { getTagValueFromResource } from "@examspark/common";
import { RichContentDisplay } from "@examspark/common-ui";
import { Resource } from "@examspark/types";

type Props = {
  resource: Pick<Resource, "name" | "tags"> | undefined | null;
  inline?: boolean;
};

const DisplayName = ({ resource, inline }: Props) => {
  if (resource != null && resource.tags === undefined) {
    console.warn(
      "Provided resource was not fetched with tags; display name cannot be evaluated.",
    );
  }

  const displayName = getTagValueFromResource(resource, "display-name");
  if (displayName != null) {
    return <RichContentDisplay content={displayName} inline={inline ?? true} />;
  }

  return <>{resource?.name ?? <i>Untitled Item</i>}</>;
};

export default DisplayName;
